import React, { useState, useEffect } from 'react'
import PhoneNumberRegistration from './components/PhoneNumberRegistration'
import { Container, Box, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { LoginPoster } from '../../components'
import { useAuth } from '../../providers'
import { useNavigate, useLocation } from 'react-router'

const useStyles = makeStyles((theme) => ({
    formTitle: {
        textAlign: 'center',
        marginBottom: '0.125rem',
        fontSize: '1.25rem',
        fontWeight: '650',
        [theme.breakpoints.up('sm')]: {
            textAlign: 'left',
        },
    },
    formSubTitle: {
        textAlign: 'center',
        fontSize: '0.9rem',
        marginBottom: '1.5rem',
        [theme.breakpoints.up('sm')]: {
            textAlign: 'left',
        },
    },
    fullWidth: {
        width: '100%',
        backgroundColor: '#ffffff',
        height: '92vh',
    },
    container: {
        width: '100%',
        padding: theme.spacing(0),
        [theme.breakpoints.up('sm')]: {
            width: '80%',
        },
    },
    form: {
        display: 'flex',
        gap: theme.spacing(2),
        justifyContent: 'space-between',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            gap: theme.spacing(0),
        },
    },
    registerForm: {
        maxWidth: '100%',
        // padding: theme.spacing(2),
        paddingRight: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        marginTop: theme.spacing(2),
        paddingTop: theme.spacing(2),
        borderTop: 'solid 1px #E5E7EB',
        boxShadow: 'inset 0px 3px 3px -3px rgba(50, 50, 50, 0.75)',
        [theme.breakpoints.up('sm')]: {
            padding: theme.spacing(4),
            // paddingTop: theme.spacing(6),
            marginTop: theme.spacing(14),
            boxShadow: theme.shadows[6],
        },
        height: '320px',
        borderRadius: '15px',
    },
    loginPoster: {
        [theme.breakpoints.up('sm')]: {
            borderBottom: 'none',
        },
    },
}))

function Register() {
    const classes = useStyles()
    const [setShowOtpVerification] = useState(false)
    const navigate = useNavigate()
    const location = useLocation()
    const { isUserLoggedIn } = useAuth()

    useEffect(() => {
        if (isUserLoggedIn) {
            navigate(location?.state?.from || '/')
        }
    }, [isUserLoggedIn, navigate, location])

    return (
        <div className={classes.fullWidth}>
            <Container className={classes.container}>
                <div className={classes.form}>
                    <div className={classes.loginPoster}>
                        <LoginPoster />
                    </div>
                    <Box className={classes.registerForm}>
                        <Typography variant="h5" component="h1" className={classes.formTitle}>
                            Register
                        </Typography>
                        <Typography variant="h5" component="p" color="textSecondary" className={classes.formSubTitle}>
                            Log In or Register to continue
                        </Typography>
                        <PhoneNumberRegistration setShowOtpVerification={setShowOtpVerification} />
                    </Box>
                </div>
            </Container>
        </div>
    )
}

export default Register
